// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-input-container {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: #fafafa;
  border-top: 1px solid #e0e0e0;
}

.chat-input-field {
  flex: 1;
  margin-bottom: 0;
  --mdc-outlined-text-field-outline-color: #1976d2;
  --mdc-outlined-text-field-hover-outline-color: #1976d2;
  --mdc-outlined-text-field-focus-outline-color: #1976d2;
  --mdc-outlined-text-field-label-text-color: #1976d2;
  --mdc-outlined-text-field-focus-label-text-color: #1976d2;
  --mdc-outlined-text-field-hover-label-text-color: #1976d2;
}
.chat-input-field ::ng-deep .mat-mdc-form-field-infix {
  padding-top: 12px;
  padding-bottom: 12px;
}
.chat-input-field textarea {
  resize: none;
  font-family: inherit;
}

.send-button {
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #1976d2 !important;
  margin-bottom: 15px;
}
.send-button:disabled {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/chat/chat-input/chat-input.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,6BAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;EAGA,gDAAA;EACA,sDAAA;EACA,sDAAA;EACA,mDAAA;EACA,yDAAA;EACA,yDAAA;AADF;AAGE;EACE,iBAAA;EACA,oBAAA;AADJ;AAIE;EACE,YAAA;EACA,oBAAA;AAFJ;;AAMA;EACE,cAAA;EACA,wCAAA;EACA,oCAAA;EACA,mBAAA;AAHF;AAKE;EACE,YAAA;AAHJ","sourcesContent":[".chat-input-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background-color: #fafafa;\n  border-top: 1px solid #e0e0e0;\n}\n\n.chat-input-field {\n  flex: 1;\n  margin-bottom: 0;\n\n  // MDC design tokens — override all outline/label states\n  --mdc-outlined-text-field-outline-color: #1976d2;\n  --mdc-outlined-text-field-hover-outline-color: #1976d2;\n  --mdc-outlined-text-field-focus-outline-color: #1976d2;\n  --mdc-outlined-text-field-label-text-color: #1976d2;\n  --mdc-outlined-text-field-focus-label-text-color: #1976d2;\n  --mdc-outlined-text-field-hover-label-text-color: #1976d2;\n\n  ::ng-deep .mat-mdc-form-field-infix {\n    padding-top: 12px;\n    padding-bottom: 12px;\n  }\n\n  textarea {\n    resize: none;\n    font-family: inherit;\n  }\n}\n\n.send-button {\n  flex-shrink: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  background-color: #1976d2 !important;\n  margin-bottom: 15px;\n\n  &:disabled {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
